<div class="container">
  <div class="hidden md:block md:mb-6">
    <app-breadcrumbs [items]="breadcrumbs"></app-breadcrumbs>
  </div>
</div>
<section class="security">
  <div class="container">
    <div class="security__card">
      <div class="section-header text-center">
        <h1 class="font-bold m-0 mobile-h1-title md:text-4xl">
          <span class="inline-block align-middle mr-1">Защитите сделку с</span>
          <span class="inline-block align-middle md:p-2 md:inline-block md:bg-lime-500 md:rounded-3xl">недвижимостью</span>
        </h1>
        <p class="text-sm md:text-base mt-4">Рассчитайте условия защиты вашей недвижимости</p>
      </div>
      <div class="flex justify-center gap-2 md:gap-3">
        <app-button
          class="w-full md:w-60 block"
          [href]="'#'"
          [type]="'button'"
          [block]="true"
          text="Рассчитать стоимость"
          color="secondary-active"
        ></app-button>
        <app-button
          class="hidden w-full md:w-60 md:block"
          [href]="'#'"
          [type]="'button'"
          [block]="true"
          text="Провести сделку"
          color="light"
        ></app-button>
        <app-button
          class="block w-full md:w-60 md:hidden"
          [href]="'#'"
          [type]="'button'"
          [block]="true"
          text="Провести сделку"
          color="secondary"
        ></app-button>
      </div>
      <img class="security__bg" src="assets/images/svg_new/lock-circle.svg" alt="#" />
    </div>
  </div>
</section>
<section class="section">
  <div class="container">
    <div class="section-header text-center">
      <h2 class="font-bold text-xl md:text-4xl">От чего мы защищаем</h2>
      <p class="text-sm md:text-base mt-4">
        Даже самые тщательные проверки не гарантируют полного устранения рисков, которые могут поставить под сомнение право собственности
      </p>
    </div>
    <div class="security-features">
      @for (item of security; track $index) {
        <div class="security-features__item">
          <div class="security-features__icon">
            <img [src]="item.icon" [alt]="item.title" />
          </div>
          <div class="security-features__title">
            {{ item.title }}
          </div>
        </div>
      }
    </div>
  </div>
</section>

<app-page-agent-features [agentFeatures]="features"></app-page-agent-features>

<app-page-callback-form
  [title]="
    `Защитите <img src=&quot;assets/images/svg_new/shield_green.svg&quot; class=&quot;w-6 md:w-9 inline-block align-middle mx-2&quot;> сделку`
  "
  [caption]="'Оставьте заявку на консультацию'"
  [agreeText]="
    `Нажимая “Получить консультацию”, я даю Согласие на обработку персональных данных в соответствии <a href=&quot;/agreement&quot;>Политикой конфиденциальности</a>`
  "
></app-page-callback-form>

<section class="section">
  <div class="container">
    <div class="section-header text-center">
      <h2 class="font-bold text-xl md:text-4xl">Как работает защита сделки</h2>
    </div>
    <div class="security-program">
      @for (item of feature; track $index) {
        <div class="security-program__item">
          <h3 class="security-program__title">{{ item.title }}</h3>
          <p class="security-program__text">
            {{ item.text }}
          </p>
          <div class="security-program__icon">
            <img [src]="item.icon" [alt]="item.title" />
          </div>
        </div>
      }
    </div>
  </div>
</section>

<app-questions [title]="'Информация об услуге'" [data]="faqs"></app-questions>

<app-page-callback-form
  [title]="'Провести сделку'"
  [caption]="'Оставьте заявку на оформление сделки'"
  [agreeText]="
    `Нажимая “Провести сделку”, я даю Согласие на обработку персональных данных в соответствии с <a href=&quot;/agreement&quot;>Политикой конфиденциальности</a>`
  "
  [submitText]="'Провести сделку'"
></app-page-callback-form>

<app-page-offers></app-page-offers>
